







































































































// 企业端pc模板
import JSEncrypt from "jsencrypt";
export default {
  name: "business-alliance",
  props: ["config"],
  data() {
    return {
      openEye: false,
      checked: false,
      avoid: false,
      aggreementList: [
        {
          title: "用户注册协议",
          url: "",
        },
        {
          title: "用户隐私协议",
          url: "",
        },
      ],
      tabList: [],
      idx: 0,
      formData: {
        loginAccount: "",
        loginCheckInfo: "",
      },
      formTest: {
        loginAccount: false,
        loginCheckInfo: false,
      },
    };
  },
  watch: {
    // formData: {
    //   handler(newCul: any) {
    //     console.log(newCul, "newCul");
    //     Object.keys(newCul).every((key) => {
    //       (this as any).test(key);
    //     });
    //   },
    //   deep: true,
    // },
    avoid: {
      handler(newCul: boolean) {
        const params: any = {
          avoid: newCul,
          time: (this as any).config.loginEffectiveTime || 0,
        };
        (this as any).$emit("avoid-login", params);
      },
      immediate: true,
    },
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
  },
  computed: {
    next: function() {
      const flag =
        (this as any).checked &&
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        );
      return flag;
    },
  },
  methods: {
    test(propName: string) {
      if (!(this as any).formData[propName]) {
        (this as any).formTest[propName] = true;
      } else {
        (this as any).formTest[propName] = false;
      }
    },
    clickFun(index: number) {
      (this as any).idx = index;
      console.log(index, "index");
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    login() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = (this as any).config;
      console.log(config, "config");
      const params = {
        account: (this as any).formData.loginAccount,
        checkInfo: instance.encryptDeal(
          (this as any).formData.loginCheckInfo
        ),
        configId: config.id,
        source: "pc",
        userType: config.userType,
        type: "01",
      };
      (this as any).$emit("login-handle", params);
    },
    goUrl(url: string) {
      window.location.href = url;
    },
  },
};
